import { useStore } from '@/store';
import { isTreeSimpleItem } from '@morph-mapper/types';
import { downloadFile } from '@/utils';
import { t } from 'i18next';
import { useNotify } from './use-notify';
import { useRenderTemplate } from './use-render-template';
import { useRuleConvert } from './use-rule-convert';

export const useExportTemplate = () => {
  /* Global state */
  const [name, entries] = useStore(({ config: c, entries: e }) => [
    c.getName(),
    e.entries,
  ]);

  /* Hooks */
  const { renderTemplate } = useRenderTemplate();
  const { convertToRules } = useRuleConvert();
  const { error } = useNotify();

  const exportTemplate = () => {
    const template = renderTemplate();
    if (!template) {
      error(t('message.error.templateRenderingFailed'));
      return;
    }

    const file = new Blob([JSON.stringify(template, null, 4)], {
      type: 'application/json',
    });

    const getUpdateTag = () => {
      const [_, node] =
        Object.entries(entries).find(([_, entry]) => entry.name === 'status') ??
        [];

      if (isTreeSimpleItem(node)) {
        return node.value === 'update' ? 'update' : undefined;
      }

      return undefined;
    };

    const updateTag = getUpdateTag();

    downloadFile(
      file,
      `${name ?? 'template'}${updateTag ? '-' + updateTag : ''}.json`,
    );
  };

  const localExport = () => {
    exportTemplate();
  };

  const localExportUpdate = () => {
    exportTemplateUpdate();
  };

  const exportTemplateUpdate = () => {
    const template = renderTemplate();
    if (!template) {
      error(t('message.error.templateRenderingFailed'));
      return;
    }

    const result = convertToRules(template);

    const file = new Blob([JSON.stringify(result, null, 4)], {
      type: 'application/json',
    });

    downloadFile(file, `${name ?? 'template'}-update.json`);
  };

  return { localExport, localExportUpdate };
};
